import { UAParser } from "ua-parser-js"

function hasMobileUserAgent(userAgent: string): boolean {
    const parser = new UAParser(userAgent)
    return parser.getResult().device.type === "mobile"
}

export { hasMobileUserAgent }
